import createIcon from '../../createIcon';

/**
 * @component @name HdrWeak
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNSA4QzIuNzkgOCAxIDkuNzkgMSAxMkMxIDE0LjIxIDIuNzkgMTYgNSAxNkM3LjIxIDE2IDkgMTQuMjEgOSAxMkM5IDkuNzkgNy4yMSA4IDUgOFpNMTcgNkMxMy42OSA2IDExIDguNjkgMTEgMTJDMTEgMTUuMzEgMTMuNjkgMTggMTcgMThDMjAuMzEgMTggMjMgMTUuMzEgMjMgMTJDMjMgOC42OSAyMC4zMSA2IDE3IDZaTTE3IDE2QzE0Ljc5IDE2IDEzIDE0LjIxIDEzIDEyQzEzIDkuNzkgMTQuNzkgOCAxNyA4QzE5LjIxIDggMjEgOS43OSAyMSAxMkMyMSAxNC4yMSAxOS4yMSAxNiAxNyAxNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HdrWeak = createIcon('HdrWeak', [
  [
    'path',
    {
      d: 'M5 8C2.79 8 1 9.79 1 12C1 14.21 2.79 16 5 16C7.21 16 9 14.21 9 12C9 9.79 7.21 8 5 8ZM17 6C13.69 6 11 8.69 11 12C11 15.31 13.69 18 17 18C20.31 18 23 15.31 23 12C23 8.69 20.31 6 17 6ZM17 16C14.79 16 13 14.21 13 12C13 9.79 14.79 8 17 8C19.21 8 21 9.79 21 12C21 14.21 19.21 16 17 16Z',
      key: '5dg0k8',
    },
  ],
]);

export default HdrWeak;
